export const DRINK_RECIPE_ITEM_TYPE = {
    Product: 'Product',
    Ingredient: 'Ingredient',
    ProductType: 'ProductType',
    ProductSubtype: 'ProductSubtype',
} as const;

export type DrinkRecipeItemType =
    (typeof DRINK_RECIPE_ITEM_TYPE)[keyof typeof DRINK_RECIPE_ITEM_TYPE];

// Ingredient Category
export const INGREDIENT_CATEGORIES = {
    Mixer: 'Mixer',
    Juice: 'Juice',
    Syrup: 'Syrup',
    Bitters: 'Bitters',
    Fresh: 'Fresh',
    Garnish: 'Garnish',
    Seasoning: 'Seasoning',
    Sweetener: 'Sweetener',
    Protein: 'Protein',
    Essential: 'Essential',
} as const;
export type IngredientCategory =
    (typeof INGREDIENT_CATEGORIES)[keyof typeof INGREDIENT_CATEGORIES];
